import { BaseQuestionnaireRoute } from '../slice';

export type WagesSubRoutes = {
  // general: BaseQuestionnaireRoute;
  incomeFromTheUs: BaseQuestionnaireRoute;
  incomeOutsideOfTheUs: BaseQuestionnaireRoute;
};

export type WagesRoutes = BaseQuestionnaireRoute & WagesSubRoutes;

export const wagesRoutes: { wages: WagesRoutes } = {
  wages: {
    title: 'Wages',
    path: 'wages',
    isValid: undefined,
    // general: {
    //   title: 'General',
    //   path: 'general',
    //   isValid: undefined,
    // },
    incomeFromTheUs: {
      title: 'Income Form The US',
      path: 'incomeFromTheUs',
      isValid: undefined,
    },
    incomeOutsideOfTheUs: {
      title: 'Income Outside The US',
      path: 'incomeOutsideOfTheUs',
      isValid: undefined,
    },
  },
};
